module.exports = __webpack_public_path__ + "static/HR Smartphone App AbaClik Mitarbeiterliste-17922cb46a3c806079548ea7852853cc.png";